import { RouteScreenContext } from '../context/RouteScreenContext';
import { useContext } from 'react';
import type { MiniRouteScreenProps } from '../schema/MiniRouteScreen.types';

interface FocusTransitionData {
    /**
     * Ref to focus on closing current route screen
     */
    focusOnClose: React.RefObject<HTMLElement>;
    /**
     * Ref to focus on opening current route screen
     */
    focusOnOpen: React.RefObject<HTMLElement>;
}

/**
 *  Hook to figure out target refs to focus on route change.
 */
const useFocusTransition = (props: MiniRouteScreenProps): FocusTransitionData => {
    const { focusOnClose, focusOnOpen } = props;

    const { parentScreenRefToFocus } = useContext(RouteScreenContext);
    const effectiveFocusOnClose = focusOnClose || parentScreenRefToFocus;

    return { focusOnClose: effectiveFocusOnClose, focusOnOpen };
};

export { useFocusTransition };
